import PropTypes from 'prop-types';

import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead,
  TableContainer, 
  TableRow 
} from '@mui/material';

import AcTableCell from './AcTableCell';
import DcTableCell from './DcTableCell';

const RevenueShareEarned = ({data}) => {

  const {
    acSockets,
    dcSockets,
    totalToClient
  } = data;

    // const hasAC = true;
    const hasAC = acSockets > 0;

    // const hasDC = true;
    const hasDC = dcSockets > 0;


  return (
    <div className="mb-6">
      <TableContainer 
        sx={{
        borderCollapse: 'separate',
        borderRadius: '15px',
        border: '1px solid rgb(224, 224, 224)',
      }}>
        <Table aria-label="revenueShareEarned">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} header data={'AC Sockets'}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} header data={'DC Sockets'}/>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Revenue share earned</TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${totalToClient.toFixed(2)}`}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${totalToClient.toFixed(2)}`}/>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default RevenueShareEarned;

RevenueShareEarned.propTypes = {
	data: PropTypes.object.isRequired,
};